declare global {
  interface Window {
    umami?: {
      track: (
        name:
          | string
          | ((payload: Record<string, unknown>) => Record<string, unknown>),
        data?: Record<string, unknown>,
      ) => void;
    };
  }
}

export function track(name: string, data?: Record<string, unknown>): void {
  if (typeof window === "undefined" || !window.umami) return;
  try {
    window.umami.track(name, { ...data, source: "mobile_pwa" });
  } catch {
    // Swallow — analytics must never break the app.
  }
}
